import { createSlice } from '@reduxjs/toolkit'

import { isFulfilledProductAvailabilityAction } from './helpers'
import { InitialProductAvailabilityListsState } from './interfaces'

const initialState: InitialProductAvailabilityListsState = {
  isLoading: true,
  productLocationAvailabilities: [],
  productLocationAvailabilitiesInfo: [],
  locationIds: [],
  productLocationAvailability: undefined,
}

export const productAvailabilityListsSlice = createSlice({
  name: 'productAvailabilityListsSlice',
  initialState,
  reducers: {
    purgeAvailabilityLists: (state) => {
      state.isLoading = true
      state.productLocationAvailabilities = []
      state.locationIds = []
      state.productLocationAvailabilitiesInfo = []
      state.productLocationAvailability = undefined
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(isFulfilledProductAvailabilityAction, (state, { payload: { calendar } }) => {
      state.productLocationAvailability = calendar

      for (const locationAvailability of calendar.locations) {
        if (locationAvailability.availabilityInfo.every((s) => s.amount === 0)) {
          console.debug(
            'Product availibility lists reducer received location without available assets:',
            locationAvailability.locationId,
          )
          continue
        }

        state.locationIds.push(locationAvailability.locationId)
        state.productLocationAvailabilities[locationAvailability.locationId] = locationAvailability.availabilityInfo
        state.productLocationAvailabilitiesInfo[locationAvailability.locationId] = locationAvailability
      }
      state.isLoading = false
    })
  },
})

export const { purgeAvailabilityLists } = productAvailabilityListsSlice.actions

export default productAvailabilityListsSlice.reducer
